module.exports = "/_next/static/images/b6f77ad571fedf974ca2abd95bd775ec-pj-man-holding-business-card@2x.jpg.webp";